document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('prescription-popup');

  // Open popup
  document.getElementById('add-prescription')?.addEventListener('click', () => {
    popup.classList.remove('hidden');
    loadLensOptions();
  });

  window.closePrescriptionPopup = function () {
    popup.classList.add('hidden');
  };

  window.goToStep = function(stepNumber) {
    document.querySelectorAll('.step').forEach(s => s.classList.remove('active'));
    document.querySelector(`.step-${stepNumber}`).classList.add('active');
  };

  function loadLensOptions() {
    fetch('/collections/lenses/products.json')
      .then(res => res.json())
      .then(data => {
        const lensSelect = document.getElementById('lens-type');
        data.products.forEach(product => {
          const option = document.createElement('option');
          option.value = product.variants[0].id;
          option.textContent = product.title;
          lensSelect.appendChild(option);
        });
      });
  }

  document.getElementById('lens-type')?.addEventListener('change', function () {
    const selectedId = this.value;
    if (!selectedId) return;

    fetch(`/products/${this.options[this.selectedIndex].text.toLowerCase().replace(/\s+/g, '-')}.js`)
      .then(res => res.json())
      .then(product => {
        const coating = document.getElementById('lens-coating');
        const strength = document.getElementById('lens-strength');
        coating.innerHTML = '<option value="">Select coating</option>';
        strength.innerHTML = '<option value="">Select strength</option>';

        product.variants.forEach(variant => {
          if (variant.option1?.toLowerCase().includes('coating')) {
            coating.innerHTML += `<option value="${variant.id}">${variant.option1} - ₵${(variant.price / 100).toFixed(2)}</option>`;
          }
          if (variant.option2?.toLowerCase().includes('strength') || variant.option1?.toLowerCase().includes('strength')) {
            strength.innerHTML += `<option value="${variant.id}">${variant.option2 || variant.option1} - ₵${(variant.price / 100).toFixed(2)}</option>`;
          }
        });

        coating.disabled = false;
        strength.disabled = false;
        document.getElementById('lens-price').innerText = `₵${(product.variants[0].price / 100).toFixed(2)}`;
      });
  });

  window.submitPrescription = function () {
    const frameId = document.querySelector('[name="id"]')?.value;
    const lensVariantId = document.getElementById('lens-type')?.value;
    const coatingId = document.getElementById('lens-coating')?.value;
    const strengthId = document.getElementById('lens-strength')?.value;

    const rxInputs = document.querySelectorAll('input[name^="rx"]');
    let rxData = '';
    rxInputs.forEach(input => {
      rxData += `${input.name}: ${input.value} | `;
    });

    const file = document.getElementById('rx-upload')?.files[0];
    const cartItems = [];

    //if (frameId) {
    //  cartItems.push({id: frameId});
    //}
   // if (lensVariantId) {
   //   cartItems.push({
    //    id: lensVariantId,
     //   properties: {
      //    'Lens Coating': coatingId,
      //    'Lens Strength': strengthId,
      //    'Rx Details': rxData,
        //  ...(file ? {'Uploaded File': file.name} : {})
      //  }
    //  });
   // }

   // const formData = new FormData();
    //formData.append('items', JSON.stringify(cartItems));

  //  fetch('/cart/add.js', {
    //  method: 'POST',
   //   headers: {'Content-Type': 'application/json'},
   //   body: JSON.stringify({ items: cartItems })
   // }).then(() => {
   //   window.location.href = '/cart';
  //  });
  };
});
